//document.addEventListener('DOMContentLoaded', function() {
document.addEventListener('DOMContentLoaded', function() {
  const slideCount = document.querySelectorAll('.hw-video-testimonials-swiper .swiper-slide').length;

  if (slideCount) {
    new Swiper('.hw-video-testimonials-swiper', {
      slidesPerView: Math.min(slideCount, 4.6),
      spaceBetween: 54,
      loop: false,
      watchOverflow: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.hw-video-next',
        prevEl: '.hw-video-prev',
      },
      pagination: {
        el: '.hw-video-testimonials__pagination',
        clickable: true,
      },
      breakpoints: {
        0:    { slidesPerView: Math.min(slideCount, 1.6), spaceBetween: 30 },
        320:  { slidesPerView: Math.min(slideCount, 2.26), spaceBetween: 16 },
        481:  { slidesPerView: Math.min(slideCount, 2.26), spaceBetween: 16 },
        768:  { slidesPerView: Math.min(slideCount, 3.25), spaceBetween: 30 },
        1024: { slidesPerView: Math.min(slideCount, 3.25), spaceBetween: 30 },
        1260: { slidesPerView: Math.min(slideCount, 3.25), spaceBetween: 30 },
        1440: { slidesPerView: Math.min(slideCount, 3.25), spaceBetween: 30 },
      },
      slidesOffsetAfter: 20
    });
  }




  
  // Modal functionality
  const modal = document.querySelector('.hw-video-modal');
  const modalIframe = document.querySelector('.hw-video-modal__iframe');
  const modalClose = document.querySelector('.hw-video-modal__close');
  const modalOverlay = document.querySelector('.hw-video-modal__overlay');

  function getVimeoVideoId(url) {
    const match = url.match(/(?:player\.vimeo\.com\/video\/|vimeo\.com\/(?:.*#|.*\/videos\/)?)(\d+)/);
    return match ? match[1] : null;
  }
  // Update the modal toggle functions to match new styling
  function openModal(videoUrl) {
    const videoId = getVimeoVideoId(videoUrl);
    if (videoId) {
      const embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0`;
      modalIframe.src = embedUrl;
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  }

  
  function closeModal() {
    modalIframe.src = '';
    modal.style.display = 'none';
    document.body.style.overflow = 'auto';
  }

  // Event listeners for play buttons
  const slides = document.querySelectorAll('.hw-video-testimonials__slide');
  
  slides.forEach(slide => {
    const playBtn = slide.querySelector('.hw-video-testimonials__play-btn');
    
    if (playBtn) {
      playBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        const videoUrl = slide.dataset.videoUrl;
        if (videoUrl) {
          openModal(videoUrl);
        }
      });
    }
  });

  // Close modal events
  modalClose.addEventListener('click', closeModal);
  modalOverlay.addEventListener('click', closeModal);

  // Close modal with ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeModal();
    }
  });
});